import { useContext, useState } from "react";

import AnswerForm from "./AnswerForm";
import AnswerList from "./AnswerList";
import { AuthContext } from "../../context/AuthProvider";

const Answer = ({
  board,
  boardItem,
  className = "",
  replyMode,
  setReplyMode,
}) => {
  const { isAdmin } = useContext(AuthContext);

  const [selectComment, setSelectComment] = useState(null);

  return !!board?.options?.useComment ? (
    <div
      className={`flex flex-col md:gap-10 gap-4 pt-10 border-t border-gray-border ${className}`}
    >
      {!!boardItem?.dateOfFirstComment && (
        <AnswerList
          board={board}
          boardItem={boardItem}
          selectComment={selectComment}
          setReplyMode={setReplyMode}
          setSelectComment={setSelectComment}
        />
      )}

      <div id="reply-form">
        {isAdmin &&
        ((replyMode && !boardItem?.dateOfFirstComment) ||
          selectComment?.commentNo) ? (
          <AnswerForm
            board={board}
            boardItem={boardItem}
            selectComment={selectComment}
            setSelectComment={setSelectComment}
            setReplyMode={setReplyMode}
          />
        ) : (
          <></>
        )}
      </div>
    </div>
  ) : null;
};

export default Answer;
